import moment from 'moment';
import { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { removeFirstAndLastThreeChars } from '../helper';
import { ACTIONS } from '../redux/actions';
import { EditableField, EditableFieldNumber } from '../Common/Input';
import McqFormation from '../Component/ManuallyGenerate/McqFormation';
import LatexTextRendererMcq from '../helper/Mathmcq';
import "../Style/EditPaper.css";
import { dynamicSequence } from '../helper/dynamicSequence';
import DynamicActionBar from '../Common/DynamicActionBar';
import { color } from 'framer-motion';
import { SuccessToast } from '../Common/Toast';
import EditableQuestion from '../Common/EditableQuestion';
const EditablePaper = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const examData = useSelector((state) => state?.SelectedDetail?.Data);

    // CKEditor CDN URL
    const editorUrl = "https://cdn.ckeditor.com/4.22.1/full-all/ckeditor.js";

    // console.log(examData, "examData");
    const priviousData = examData;
    const [paperData, setPaperData] = useState({
        school_name: examData?.school_name,
        subject_name: examData?.subject_name,
        exam_name: examData?.exam_name,
        exam_date: examData?.exam_date,
        standard_name: examData?.standard_name,
        exam_marks: examData?.exam_marks,
        chapter_name: examData?.chapter_name,
        exam_time: examData?.exam_time,
    });
    // Create a local state to manage editable fields
    const [editableData, setEditableData] = useState(JSON.parse(JSON.stringify(examData)));
    // Update local state when Redux state changes
    useEffect(() => {
        setEditableData(prev => {
            if (JSON.stringify(prev) !== JSON.stringify(examData)) {
                return { ...examData };
            }
            return prev;
        });
    }, [examData]);

    const handleOperPaperEditScreen = () => {
        dispatch(ACTIONS.getSelectedData(editableData));
        SuccessToast("Changes saved successfully!");
        navigate(-1);
    };

    const handleBackClick = (e) => {
        e.preventDefault();
        navigate(-1);
    };

    const handleBack = () => {
        navigate(-1);
    };

    const actions = [
        { label: "Save Changes", isBordered: true, onClick: handleOperPaperEditScreen },
        { label: "Cancel", onClick: handleBack },
    ];

    const fontFamily = ['Times New Roman', 'Arial', 'Courier New'];
    const overAllFontSize = editableData?.font_size || 18;
    const headingSize = editableData?.heading_size || 22;
    const watermarkSize = editableData?.watermark_size || 25;
    const watermarkOpacity = editableData?.watermark_opacity || 50;

    const paperType = editableData?.paperType;

    const isExamPaperExamdate =
        (editableData?.paperType === 0 || editableData?.paperType === 1) &&
        editableData?.exam_date;

    const isWithSection = editableData?.genrate_type == "with section" ? true : false;

    const handalLineChnage = (value = "Add", sectionIndex, divIndex, qIndex) => {
        setEditableData(prev => {
            const updated = { ...prev };
            const currentVal = Number(
                updated.sections_info[sectionIndex]
                    .divisions[divIndex]
                    .question_data[qIndex]
                    .QtypeInfo
                    .worksheet_space
            ) || 1;

            updated.sections_info[sectionIndex]
                .divisions[divIndex]
                .question_data[qIndex]
                .QtypeInfo
                .worksheet_space = value === "Add" ? currentVal + 1 : currentVal - 1;

            return updated;
        });
    }




    const handleInputChange = useCallback((fieldPath, newValue) => {
        // const handleInputChange = (fieldPath, newValue) => {

        setEditableData(prev => {
            let updated = structuredClone(prev);

            const pathSegments = fieldPath.replace(/\[(\d+)\]/g, '.$1').split('.');
            const lastKey = pathSegments[pathSegments.length - 1];

            // Traverse and update the specific field
            let obj = updated;
            for (let i = 0; i < pathSegments.length - 1; i++) {
                obj = obj[pathSegments[i]];
            }
            obj[lastKey] = newValue;

            // Recalculate total marks
            if (fieldPath.includes('marks')) {
                let total = 0;
                updated.sections_info?.forEach(section => {
                    section.divisions?.forEach(division => {
                        const m = parseFloat(division.marks);
                        if (!isNaN(m)) total += m;
                    });
                });
                updated.exam_marks = total;
            }

            if (fieldPath.includes('question_id')) {
                const sectionIndex = parseInt(fieldPath.match(/sections_info\[(\d+)\]/)?.[1]);
                const divIndex = parseInt(fieldPath.match(/divisions\[(\d+)\]/)?.[1]);
                const qIndex = parseInt(fieldPath.match(/question_data\[(\d+)\]/)?.[1]);

                const base = parseInt(newValue);
                if (!isNaN(base)) {
                    let questionCounter = base;
                    let foundStart = false;
                    let skipFirst = true;

                    let currentGroupType = null; // 'and' | 'or' | null
                    let andGroupId = null;
                    let previousQuestionId = null;


                    updated.sections_info.forEach((section, sIdx) => {
                        section.divisions.forEach((division, dIdx) => {
                            division.question_data.forEach((question, qIdx) => {
                                // Skip until we find the starting question
                                if (
                                    !foundStart &&
                                    sIdx === sectionIndex &&
                                    dIdx === divIndex &&
                                    qIdx === qIndex
                                ) {
                                    foundStart = true;
                                    currentGroupType = null;
                                    andGroupId = null;
                                    previousQuestionId = base;
                                    if (question?.andId != 1) {
                                        questionCounter++;
                                    }
                                    return; // Skip the edited question itself
                                }
                                if (!foundStart || !question) return;

                                if (question.isAnd) {
                                    if (currentGroupType !== 'and' || question?.andId == 1) {
                                        currentGroupType = 'and';
                                        andGroupId = questionCounter++;
                                    }
                                    question.question_id = andGroupId;
                                    previousQuestionId = andGroupId;
                                } else if (question.isOr) {
                                    currentGroupType = 'or';
                                    question.question_id = previousQuestionId;
                                    // previousQuestionId stays the same
                                } else {
                                    currentGroupType = null;
                                    andGroupId = null;
                                    if (question?.question_id) {

                                        question.question_id = questionCounter++;
                                        previousQuestionId = question.question_id;
                                    }
                                }
                            });
                        });
                    });
                }
            }


            const updatedSections = dynamicSequence(updated?.sections_info, true);
            updated.sections_info = updatedSections;

            return updated;
        });
    }, []);

    return (
        <div className="editable-paper-container">

            <div className="sticky top-0 z-[100] bg-[#F6F7F9]">
                <DynamicActionBar
                    showArrowLeft
                    backButtonLabel={"Back to Preview"}
                    onBackClick={handleBackClick}
                    actions={actions}
                />
            </div>



            <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', justifyContent: 'center' }}>
                {editableData?.institute_logo ? (
                    <img src={editableData?.institute_logo} alt="Logo" style={{ width: '40rem', height: '6rem', marginBottom: '8px' }} />
                ) : (
                    <h1 style={{ color: 'red', marginBottom: '0px', fontSize: `${headingSize}px`, display: 'flex', flex: 1, textAlign: 'center', justifyContent: 'center', width: '90%' }}>
                        <EditableField
                            value={editableData.school_name}
                            onChange={(value) => handleInputChange('school_name', value)}
                            overAllFontSize={overAllFontSize}
                            style={{ fontSize: `${headingSize}px`, textAlign: 'center', width: '100%', color: 'black' }}
                        />
                    </h1>
                )}
            </div>

            <hr />

            <div>
                <div className="parent" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <p className="exam-title">Subject:
                        <EditableField
                            overAllFontSize={overAllFontSize}
                            value={editableData?.subject_name}
                            onChange={(value) => handleInputChange('subject_name', value)}
                        />
                    </p>

                    {editableData?.exam_name !== undefined && (
                        <p className="exam-title">
                            <EditableField
                                overAllFontSize={overAllFontSize}
                                value={editableData?.exam_name}
                                onChange={(value) => handleInputChange('exam_name', value)}
                                style={{ width: '310px' }}
                            />
                        </p>
                    )}

                    {isExamPaperExamdate && (
                        <p className="exam-title" id="subject-name">Date:
                            <EditableField
                                overAllFontSize={overAllFontSize}
                                type="date"
                                value={editableData?.exam_date ? moment(editableData?.exam_date).format('YYYY-MM-DD') : ''}
                                onChange={(value) => handleInputChange('exam_date', value)}
                            />
                        </p>
                    )}
                </div>

                <div className="parent" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <p className="exam-title">Standard:
                        <EditableField
                            overAllFontSize={overAllFontSize}
                            value={editableData?.standard_name}
                            onChange={(value) => handleInputChange('standard_name', value)}
                        />
                    </p>

                    {editableData.exam_marks && (
                        <p className="exam-title" id="subject-name">Marks:
                            <EditableField
                                overAllFontSize={overAllFontSize}
                                value={editableData.exam_marks}
                                onChange={(value) => handleInputChange('exam_marks', value)}
                                type="number"
                                style={{ width: '255px' }}
                            />
                        </p>
                    )}
                </div>

                <div className="parent" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    {editableData.chapter_name !== undefined && (
                        <p className="exam-title">Chapter:
                            <EditableField
                                overAllFontSize={overAllFontSize}
                                value={editableData.chapter_name || ''}
                                placeholder="Enter Chapter Name"
                                onChange={(value) => handleInputChange('chapter_name', value)}
                            />
                        </p>
                    )}



                    {editableData?.exam_time?.trim() !== undefined && (
                        <p className="exam-title" id="subject-name">Exam Time:
                            <EditableField
                                overAllFontSize={overAllFontSize}
                                value={editableData?.exam_time}
                                onChange={(value) => handleInputChange('exam_time', value)}
                            />
                        </p>
                    )}



                </div>
            </div>

            <hr />


            {/* Sections */}
            {editableData?.sections_info?.map((section, sectionIndex) => (
                <section key={`section-${sectionIndex}`} style={{ paddingTop: '15px' }}>

                    {section.section_name !== undefined && (
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <h2 style={{ textAlign: 'center', textDecoration: 'underline', fontFamily: fontFamily, fontSize: `${overAllFontSize}px` }}>
                                <EditableField
                                    overAllFontSize={overAllFontSize}
                                    value={section.section_name}
                                    onChange={(value) => handleInputChange(`sections_info[${sectionIndex}].section_name`, value)}
                                    style={{ textAlign: 'center', textDecoration: 'underline' }}
                                />
                            </h2>
                        </div>
                    )}



                    {section?.sectionNotice !== undefined && <div>
                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                            <p className="random_genrate_notice">• &nbsp;</p>
                            <p className="random_genrate_notice">
                                {/* {division.questionTitle ? division.questionTitle + " - " : ""} */}
                                <EditableField
                                    overAllFontSize={overAllFontSize}
                                    value={section?.sectionNotice}
                                    onChange={(value) => handleInputChange(`sections_info[${sectionIndex}].sectionNotice`, value)}
                                    style={{ fontWeight: 'bold', width: '100vh' }}
                                />
                            </p>
                        </div>
                    </div>
                    }

                    {/* Divisions */}
                    {section?.divisions?.map((division, divIndex) => (
                        <div key={divIndex}>
                            {division?.random_genrate_notice !== undefined && (
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexDirection: 'row', padding: '0px', margin: '0px' }}>
                                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                                        <p className="random_genrate_notice">• &nbsp;</p>
                                        <p className="random_genrate_notice">
                                            {division.questionTitle ? division.questionTitle + " - " : ""}
                                            <EditableField
                                                overAllFontSize={overAllFontSize}
                                                value={division.random_genrate_notice}
                                                onChange={(value) => handleInputChange(`sections_info[${sectionIndex}].divisions[${divIndex}].random_genrate_notice`, value)}
                                                style={{ fontWeight: 'bold', width: '100vh' }}
                                            />
                                        </p>
                                    </div>
                                    <p style={{ fontSize: `${overAllFontSize}px`, padding: '0', margin: '0' }}>
                                        (<EditableField
                                            overAllFontSize={overAllFontSize}
                                            value={division.marks}
                                            onChange={(value) => handleInputChange(`sections_info[${sectionIndex}].divisions[${divIndex}].marks`, value)}
                                            type="number"
                                            style={{ width: '45px', textAlign: 'center' }}
                                        />)
                                    </p>
                                </div>
                            )}

                            {/* <h2>Ankit</h2> */}



                            {/* <h2>Queston</h2> */}
                            {division?.random_genrate_notice && (
                                <div style={{ minHeight: 'fit-content', padding: '0', margin: '0' }}>
                                    <ol>
                                        {division?.question_data?.map((question, qIndex) => {
                                            console.log(question, "question");
                                            const question_id =
                                                question?.question_id > 0 && (question?.andId || 0) <= 1
                                                    ? `${Number(question?.question_id).toString().padStart(2, '0')}.` +
                                                    (question?.andId ? ` (${String.fromCharCode((question?.andId || 0) + 96)})` : '')

                                                    : question?.question_id > 0
                                                        ? `(${String.fromCharCode((question?.andId || 0) + 96)})`
                                                        : paperType === 2
                                                            ? '\u00A0\u00A0\u00A0\u00A0\u00A0'
                                                            : question?.question_id === 0 && qIndex > 99
                                                                ? '\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0'
                                                                : '\u00A0\u00A0\u00A0\u00A0\u00A0';


                                            return (

                                                <>
                                                    {question?.isOr
                                                        ? <>
                                                            <br />
                                                            <p style={{
                                                                fontSize: `18px`,
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                margin: 0,
                                                                padding: '0 0 6px 0'
                                                            }}>OR</p>
                                                            <br />
                                                        </>
                                                        : ""}

                                                    {question?.paragraph
                                                        && <p
                                                            style={{
                                                                padding: "15px 0 5px 0",
                                                                margin: "0",
                                                                textAlign: "justify",
                                                                fontWeight: "bold",
                                                                fontSize: "16px"
                                                            }}
                                                            dangerouslySetInnerHTML={{
                                                                __html: removeFirstAndLastThreeChars(question?.paragraph || "")
                                                            }}
                                                        ></p>


                                                    }

                                                    <div key={qIndex} style={{ padding: question?.QtypeInfo?.name.includes('Match the Following') ? '0' : '10px 0 0 0 ', margin: '0', display: 'flex', flexDirection: 'row' }}>

                                                        <>

                                                            {!question?.QtypeInfo?.name.includes('Match the Following') && <p>


                                                                <div style={{ display: 'flex' }}>

                                                                    <EditableFieldNumber
                                                                        overAllFontSize={overAllFontSize}
                                                                        value={String(question?.question_id)} // Force to string
                                                                        onChange={(value) =>
                                                                            handleInputChange(
                                                                                `sections_info[${sectionIndex}].divisions[${divIndex}].question_data[${qIndex}].question_id`,
                                                                                Number(value) // Convert to number
                                                                            )
                                                                        }
                                                                        style={{ textAlign: 'center', width: '45px' }}
                                                                    />

                                                                    {question?.andId ? <b>  ({String.fromCharCode(96 + question.andId)}) </b> : null}

                                                                </div>

                                                            </p>}



                                                            &nbsp;
                                                            {question?.m_equation != 1 ? (
                                                                // **********************without m_equation*************************
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        flexDirection: "column",
                                                                        width: "-webkit-fill-available",
                                                                        overflow: "auto",
                                                                    }}
                                                                >

                                                                    {!question?.QtypeInfo?.name.includes('Match the Following') && <EditableQuestion
                                                                        question={question?.question}
                                                                        finalquestion={question?.finalquestion}
                                                                        onChangefinalQuestion={(newValue) => handleInputChange(
                                                                            `sections_info[${sectionIndex}].divisions[${divIndex}].question_data[${qIndex}].finalquestion`,
                                                                            newValue
                                                                        )}
                                                                        onChangeQuestion={(newValue) => handleInputChange(
                                                                            `sections_info[${sectionIndex}].divisions[${divIndex}].question_data[${qIndex}].question`,
                                                                            newValue
                                                                        )}
                                                                        overAllFontSize={overAllFontSize}
                                                                        editorUrl={editorUrl}
                                                                    />}


                                                                    {paperType == 3 &&
                                                                        !(question?.questionLeft || question?.questionRight)
                                                                        ? (
                                                                            <>
                                                                                <div>
                                                                                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                                                                                        <div>
                                                                                            <h2>Ans</h2>
                                                                                        </div>
                                                                                        <div style={{ flex: 1, borderBottom: '1.5px dashed black' }}></div>
                                                                                    </div>
                                                                                </div>
                                                                                <div style={{ marginLeft: '40px' }}>
                                                                                    {question?.QtypeInfo?.worksheet_space > 1 &&
                                                                                        Array.from({ length: Number(question?.QtypeInfo?.worksheet_space - 1) }).map((_, index) => (
                                                                                            <div key={index}>
                                                                                                <div style={{ flex: 1, padding: '10px', borderBottom: '1.5px dashed black' }} />
                                                                                            </div>
                                                                                        ))}
                                                                                </div>
                                                                                <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                                                                                    <button
                                                                                        onClick={() => handalLineChnage("Sub", sectionIndex, divIndex, qIndex)}
                                                                                        className="mr-2 px-2 py-1 border border-red-500 text-red-700 bg-red-100 hover:bg-red-200 rounded"
                                                                                    >
                                                                                        −
                                                                                    </button>


                                                                                    <span>{question?.QtypeInfo?.worksheet_space ?? 1}</span>

                                                                                    <button
                                                                                        onClick={() => handalLineChnage("Add", sectionIndex, divIndex, qIndex)}
                                                                                        className="ml-2 px-2 py-1 border border-sky-500 text-sky-700 bg-sky-100 hover:bg-sky-200 rounded"
                                                                                    >
                                                                                        ＋
                                                                                    </button>

                                                                                </div>



                                                                            </>
                                                                        ) : (
                                                                            ''
                                                                        )}


                                                                    {(question?.option1_img ||
                                                                        question?.option2_img ||
                                                                        question?.option3_img ||
                                                                        question?.option4_img ||
                                                                        question?.finaloption1 ||
                                                                        question?.finaloption2 ||
                                                                        question?.finaloption3 ||
                                                                        question?.finaloption4) && <McqFormation question={question} />}



                                                                    {(question?.questionLeft || question?.questionRight) ? (
                                                                        <>


                                                                            {(question?.questionLeft || question?.questionRight) && question?.paragraph && (
                                                                                <>





                                                                                    <div className="question-container" style={{ marginTop: '5px' }}>
                                                                                        <p style={{ paddingRight: '28px' }}>

                                                                                            {question?.question_id > 99 ? '\u00A0'.repeat(5) : '\u00A0'.repeat(5)}
                                                                                        </p>
                                                                                        <div className="question-column">
                                                                                            <p className="pppp">A</p>
                                                                                        </div>
                                                                                        <div className="question-column">
                                                                                            <p className="pppp">B</p>
                                                                                        </div>
                                                                                        {paperType === 2 && question?.rightAnswer && (
                                                                                            <div className="answer-column">
                                                                                                <p className="pppp">Answer</p>
                                                                                            </div>
                                                                                        )}
                                                                                    </div>

                                                                                </>
                                                                            )}

                                                                            <div className="question-container">
                                                                                {!question.isOr && (
                                                                                    <>
                                                                                        <EditableFieldNumber
                                                                                            overAllFontSize={overAllFontSize}
                                                                                            value={question?.question_id}
                                                                                            // type="text"
                                                                                            onChange={(value) => handleInputChange(`sections_info[${sectionIndex}].divisions[${divIndex}].question_data[${qIndex}].question_id`, value)}
                                                                                            style={{ textAlign: 'center', width: '45px' }}
                                                                                        />


                                                                                    </>
                                                                                )}
                                                                                <div className="question-column">
                                                                                    {question?.questionLeft && (
                                                                                        <p style={{ paddingLeft: '8px', paddingTop: '5px', paddingBottom: '5px' }}>{question.questionLeft}</p>
                                                                                    )}
                                                                                </div>
                                                                                <div className="question-column">
                                                                                    {question?.questionRight && (
                                                                                        <p style={{ paddingLeft: '8px', paddingTop: '5px', paddingBottom: '5px' }}>{question.questionRight}</p>
                                                                                    )}
                                                                                </div>
                                                                                {paperType === 2 && question?.questionRight && question?.rightAnswer && (
                                                                                    <div className="answer-column">
                                                                                        <p style={{ paddingLeft: '8px' }} className="pppp">
                                                                                            {question?.rightAnswer}
                                                                                        </p>
                                                                                    </div>
                                                                                )}


                                                                            </div>
                                                                        </>
                                                                    ) : (
                                                                        ""
                                                                    )}
                                                                    {/* </li> */}
                                                                </div>
                                                            ) : (
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        flexDirection: "column",
                                                                        width: "-webkit-fill-available",
                                                                        overflow: "auto",
                                                                    }}
                                                                >
                                                                    {/* *****************************with m_equation********************************** */}
                                                                    {!question?.QtypeInfo?.name.includes('Match the Following') && <EditableQuestion
                                                                        question={question?.question}
                                                                        finalquestion={question?.finalquestion}
                                                                        onChangefinalQuestion={(newValue) => handleInputChange(
                                                                            `sections_info[${sectionIndex}].divisions[${divIndex}].question_data[${qIndex}].finalquestion`,
                                                                            newValue
                                                                        )}
                                                                        onChangeQuestion={(newValue) => handleInputChange(
                                                                            `sections_info[${sectionIndex}].divisions[${divIndex}].question_data[${qIndex}].question`,
                                                                            newValue
                                                                        )}
                                                                        overAllFontSize={overAllFontSize}
                                                                        editorUrl={editorUrl}
                                                                    />}

                                                                    <LatexTextRendererMcq text={question} />

                                                                    {paperType == 3 &&
                                                                        !(question?.questionLeft || question?.questionRight)
                                                                        ? (
                                                                            <>
                                                                                <div>
                                                                                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                                                                                        <div>
                                                                                            <h2>Ans</h2>
                                                                                        </div>
                                                                                        <div style={{ flex: 1, borderBottom: '1.5px dashed black' }}></div>
                                                                                    </div>
                                                                                </div>
                                                                                <div style={{ marginLeft: '40px' }}>
                                                                                    {question?.QtypeInfo?.worksheet_space > 1 &&
                                                                                        Array.from({ length: Number(question?.QtypeInfo?.worksheet_space - 1) }).map((_, index) => (
                                                                                            <div key={index}>
                                                                                                <div style={{ flex: 1, padding: '10px', borderBottom: '1.5px dashed black' }} />
                                                                                            </div>
                                                                                        ))}
                                                                                </div>
                                                                                <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                                                                                    <button
                                                                                        onClick={() => handalLineChnage("Sub", sectionIndex, divIndex, qIndex)}
                                                                                        className="mr-2 px-2 py-1 border border-red-500 text-red-700 bg-red-100 hover:bg-red-200 rounded"
                                                                                    >
                                                                                        −
                                                                                    </button>


                                                                                    <span>{question?.QtypeInfo?.worksheet_space ?? 1}</span>

                                                                                    <button
                                                                                        onClick={() => handalLineChnage("Add", sectionIndex, divIndex, qIndex)}
                                                                                        className="ml-2 px-2 py-1 border border-sky-500 text-sky-700 bg-sky-100 hover:bg-sky-200 rounded"
                                                                                    >
                                                                                        ＋
                                                                                    </button>



                                                                                </div>



                                                                            </>
                                                                        ) : (
                                                                            ''
                                                                        )}

                                                                    {(question?.questionLeft || question?.questionRight) ? (
                                                                        <>
                                                                            {(question?.questionLeft || question?.questionRight) && question?.paragraph && (

                                                                                <>


                                                                                    <div className="question-container " style={{ marginTop: '5px' }}>
                                                                                        <p style={{ paddingRight: '28px' }}>
                                                                                            {question?.question_id > 99 ? '\u00A0'.repeat(5) : '\u00A0'.repeat(5)}
                                                                                        </p>
                                                                                        <div className="question-column">
                                                                                            <p className="pppp">A</p>
                                                                                        </div>
                                                                                        <div className="question-column">
                                                                                            <p className="pppp">B</p>
                                                                                        </div>
                                                                                        {paperType === 2 && question?.rightAnswer && (
                                                                                            <div className="answer-column">
                                                                                                <p className="pppp">Answer</p>
                                                                                            </div>
                                                                                        )}


                                                                                    </div>

                                                                                </>
                                                                            )}

                                                                            <div className="question-container">
                                                                                {!question.isOr
                                                                                    ? (

                                                                                        <>
                                                                                            <EditableFieldNumber

                                                                                                overAllFontSize={overAllFontSize}
                                                                                                value={String(question?.question_id)} // Force to string
                                                                                                onChange={(value) =>
                                                                                                    handleInputChange(
                                                                                                        `sections_info[${sectionIndex}].divisions[${divIndex}].question_data[${qIndex}].question_id`,
                                                                                                        Number(value) // Convert to number
                                                                                                    )
                                                                                                }
                                                                                                style={{ textAlign: 'center', width: '45px' }}
                                                                                            />

                                                                                        </>

                                                                                    ) : <p style={{ textAlign: 'center', width: '32px' }}></p>}



                                                                                <div
                                                                                    className="question-column"
                                                                                    style={{ paddingLeft: '8px', paddingTop: '5px', paddingBottom: '5px' }}
                                                                                    dangerouslySetInnerHTML={{ __html: question?.questionLeft }}
                                                                                />

                                                                                <div
                                                                                    className="question-column"
                                                                                    style={{ paddingLeft: '8px', paddingTop: '5px', paddingBottom: '5px' }}
                                                                                    dangerouslySetInnerHTML={{ __html: question?.questionRight }}
                                                                                />

                                                                                {paperType === 2 && question?.questionRight && question?.rightAnswer && (
                                                                                    <div
                                                                                        className="answer-column pppp"
                                                                                        style={{ paddingLeft: '8px' }}
                                                                                        dangerouslySetInnerHTML={{ __html: question?.questionRight }} />
                                                                                )}

                                                                                {/* {console.log(paperType, !!(question?.questionLeft || question?.questionRight), 'paperType')} */}


                                                                            </div>
                                                                        </>
                                                                    ) : (
                                                                        ""
                                                                    )}
                                                                </div>
                                                            )}
                                                        </>
                                                    </div >
                                                </>
                                            );
                                        })}
                                    </ol>
                                </div>
                            )}
                        </div>
                    ))}
                </section>
            ))
            }

            {/* Final message */}
            {
                editableData?.last_message !== undefined && (
                    <p className="last-message " style={{ marginTop: '20px', marginBottom: '90px', textAlign: 'center' }}>

                        <EditableField
                            overAllFontSize={overAllFontSize}
                            value={editableData?.last_message || ''}
                            onChange={(value) => handleInputChange('last_message', value)}
                            style={{ fontSize: '30px', fontFamily: "'Sofia', sans-serif" }}
                        />
                    </p>
                )
            }

        </div >
    );
};

export default EditablePaper;